import { MICRO_CONVERSION } from '@/utils/money';

/** Parse a user-entered price string to micros; non-numeric input yields 0. */
export const parsePriceToMicros = (price: string): number => {
  const parsed = parseFloat(price);
  return isNaN(parsed) ? 0 : Math.round(parsed * MICRO_CONVERSION);
};

/** Parse a user-entered quantity string to a number; non-numeric input yields 0. */
export const parseQuantity = (quantity: string): number => {
  const parsed = parseFloat(quantity);
  return isNaN(parsed) ? 0 : parsed;
};
